// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yrVX","option":"styles_option__WpDhJ","selected":"styles_selected__1CAQQ"};